import { useCallback, useState } from "react";

/**
 * Supports controlled or uncontrolled state: uses `controlledValue` when defined,
 * otherwise keeps local state initialized to `defaultValue`.
 *
 * @template T
 * @param {T|undefined} controlledValue
 * @param {((value: T) => void)|undefined} onChange
 * @param {T} defaultValue
 * @returns {[T, (value: T) => void]}
 */
export function useControllableState(controlledValue, onChange, defaultValue) {
  const [internalValue, setInternalValue] = useState(defaultValue);
  const isControlled = controlledValue !== undefined;
  const value = isControlled ? controlledValue : internalValue;

  const setValue = useCallback(
    (next) => {
      if (onChange) onChange(next);
      if (!isControlled) setInternalValue(next);
    },
    [onChange, isControlled]
  );

  return [value, setValue];
}
